import * as React from 'react';
import { NavBarProp } from './types';
import { Link } from 'react-router-dom';
import { GAFormEvent } from '../../utils/analyticsFunctions';
import MenuType from '../NavBar/types';
import * as H from 'history';
// import codehubsvg from '../../../public/images/codehub.svg'

export interface NavItemProps {
  menu: MenuType;
  hideNavBar: boolean;
  history: H.History;
  showHeader: () => void;
  hideNotification: () => void;
}

const NavItem = (props: NavItemProps) => {
  const { menu, hideNavBar, history, showHeader } = props;
  return (
    <li
      className={history.location.pathname === menu.url ? 'nav-active' : ''}
      title={hideNavBar ? menu.title.toUpperCase() : ''}
      onClick={props.hideNotification}>
      {
        menu.url.includes("http") ?
          //TODO: uncomment if you want notebook in sidebar
          // TODO: there are desgin changes to come so for quick work, svg is imported.
          <a href={menu.url} target="_blank">
            <i className="fuse-icon fuse-icon-codehub" />
            <span className="nav-cnt text-ellipsis">{menu.title.toUpperCase()}</span>

          </a>
          :
          <Link
            to={`${menu.url}`}
            onClick={() => {
              if (menu.url === 'profile') { GAFormEvent('Cl_Profile') }
              showHeader();
            }}>
            {
              menu.image ?
                <span >
                  <i className="fuse-icon fuse-icon-profile " />
                </span>
                : <i className={menu.classname} />
            }
            <span className="nav-cnt text-ellipsis">{menu.title.toUpperCase()}</span>
            {
              menu.totalNotification && menu.totalNotification > 0 && history.location.pathname !== '/billing' ?
                <span className="nav-notification text-ellipsis">{menu.totalNotification}</span>
                : null
            }
          </Link>
      }
    </li>
  );
};

const SideBar = (props: NavBarProp) => {
  const { topMenus, hideNavBar, showHeader } = props;

  return (
    <aside role="left-sidebar">
      <nav className="sidebar-nav top-nav">
        <ul onClick={props.detectMobileEvent}>
          {topMenus.map((menus: any, index) => {
            return (
              <NavItem key={index} menu={menus}
                history={props.history}
                hideNavBar={hideNavBar}
                showHeader={showHeader}
                hideNotification={props.hideNotification} />
            );
          })}
        </ul>
      </nav>
      {/* <nav className="sidebar-nav bottom-nav">
        <ul>
          {bottomMenus.map((menus: any) => {
            return (
              <NavItem key={menus.id} menu={menus} hideNavBar={hideNavBar} id="bottomMenu"/>
            );
          })}
        </ul>
      </nav> */}
    </aside>
  );
};

export default SideBar;
